import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';

import InsertPhotoIcon from '@material-ui/icons/InsertPhoto';

import combineStyles from '../../utils/combineStyles';
import InvoicePreviewStyles from './__styles__/InvoicePreview.styles';

export class InvoicePreview extends PureComponent {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <InsertPhotoIcon className={classes.icon} />
      </div>
    );
  }
}

export default withStyles(combineStyles(InvoicePreviewStyles))(InvoicePreview);
